import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.ul`
  margin: 8px;
  display: flex;
  overflow-x: auto;
  width: calc(100% - 132px);
`;
